import React, { useMemo, useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { convertMinutesToHoursAndMinutes, fetchMxBorderCrossKPIs, getDeltaMonthFormatedDate, rgbToRgba } from "./helpers";
import { CardFrame } from "components/UI/CardFrame";
import KPIElement from 'components/UI/KPIElement';
import "assets/css/orders-heatmap.css";
import StepChart from './StepChart';

const MXBorderCrossKPIs = () => {
    const [mxBorderKPIs, setMxBorderKPIs] = useState(null);
    const [startDate, setStartDate] = useState("2024-11-06"); // Set default state to today's date - 1 month
    const [endDate, setEndDate] = useState(getDeltaMonthFormatedDate(0)); // Set default state to today's date

    useEffect(() => {
        fetchMxBorderCrossKPIs(setMxBorderKPIs, startDate, endDate);
    }, [startDate, endDate]);

    const dataSet = (title, data, color) => ({
        label: title,
        data: Object.values(data),
        backgroundColor: rgbToRgba(color, 0.4),
        borderColor: color,
        fill: false,
        stepped: true,
    });

    const dataSets = mxBorderKPIs
        ? [
            dataSet("MXNB", mxBorderKPIs.CrossingsPerDay.MXNB, "rgb(54, 162, 235)"),
            dataSet("MXSB", mxBorderKPIs.CrossingsPerDay.MXSB, "rgb(255, 206, 86)")
          ]
        : [];

    const buttonGroupComponent = useMemo(() => (
        <>
            {/* <div className="row align-items-center text-center">
                <div className="col-12 mb-3" style={{ width: 'auto' }}>
                    Cross Border Analytics
                </div>
            </div> */}
            <div className="row">
                <div className="col-3 form-group">
                    <label className="label-text">Filter Start:</label>
                    <Form.Control
                        defaultValue={startDate}
                        className="btn btn-sm tab-btn"
                        type="date"
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-6 text-center">
                    Cross Border Analytics
                </div>
                <div className="col-3 justify-content-end form-group">
                    <label className="label-text">Filter End:</label>
                    <Form.Control
                        value={endDate}
                        className="btn btn-sm tab-btn"
                        type="date"
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
            </div>
        </>
    ), [startDate, endDate]);

    return (
        <CardFrame title={buttonGroupComponent}>
            {mxBorderKPIs ? (
                <div className="row">
                    <div className="col-3 mb-2">
                        <KPIElement
                            title="MXNB Mean Cross Time"
                            value={convertMinutesToHoursAndMinutes(mxBorderKPIs.AvgCrossInterval.MXNB)}
                            unit="hours"
                        />
                    </div>
                    <div className="col-3 mb-2">
                        <KPIElement
                            title="MXNB Number of Crossings"
                            value={Object.values(mxBorderKPIs.CrossingsPerDay.MXNB).reduce((acc, val) => acc + val, 0)}
                            unit="trucks"
                        />
                    </div>
                    <div className="col-3 mb-2">
                        <KPIElement
                            title="MXSB Mean Cross Time"
                            value={convertMinutesToHoursAndMinutes(mxBorderKPIs.AvgCrossInterval.MXSB)}
                            unit="hours"
                        />
                    </div>
                    <div className="col-3 mb-2">
                        <KPIElement
                            title="MXSB Number of Crossings"
                            value={Object.values(mxBorderKPIs.CrossingsPerDay.MXSB).reduce((acc, val) => acc + val, 0)}
                            unit="trucks"
                        />
                    </div>
                    <div className="col-12" style={{width: '100%'}}>
                        <StepChart
                            title="MX Crossings / Day"
                            ChartData={mxBorderKPIs.CrossingsPerDay.MXNB}
                            Datasets={dataSets}
                        />
                    </div>
                </div>
            ) : null}
        </CardFrame>
    );
};

export default MXBorderCrossKPIs;
